import _codegen from "../../compile/codegen";
import _util from "../../compile/util";
import _equal from "../../runtime/equal";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const codegen_1 = _codegen;
const util_1 = _util;
const equal_1 = _equal;
const error = {
  message: "must be equal to constant",
  params: ({
    schemaCode
  }) => (0, codegen_1._)`{allowedValue: ${schemaCode}}`
};
const def = {
  keyword: "const",
  $data: true,
  error,
  code(cxt) {
    const {
      gen,
      data,
      $data,
      schemaCode,
      schema
    } = cxt;
    if ($data || schema && typeof schema == "object") {
      cxt.fail$data((0, codegen_1._)`!${(0, util_1.useFunc)(gen, equal_1.default)}(${data}, ${schemaCode})`);
    } else {
      cxt.fail((0, codegen_1._)`${schema} !== ${data}`);
    }
  }
};
exports.default = def;
//# sourceMappingURL=const.js.map
export default exports;
export const __esModule = exports.__esModule;